export const translateCategory = (category: string) => {
  switch (category) {
    case 'Action':
      return 'Ação'
    case 'Indie':
      return 'Indie'
    case 'Adventure':
      return 'Aventura'
    case 'RPG':
      return 'RPG'
    case 'Shooter':
      return 'Tiro'
    case 'Casual':
      return 'Casual'
    case 'Simulation':
      return 'Simulação'
    case 'Puzzle':
      return 'Quebra-cabeças'
    case 'Strategy':
      return 'Estratégia'
    case 'Sports':
      return 'Esportes'
    case 'Racing':
      return 'Corrida'
    case 'Massively Multiplayer':
      return 'Multiplayer'
    case 'Fighting':
      return 'Luta'
    case 'Platform':
      return 'Plataforma'
    case 'All':
    default:
      return category
  }
}
